// Copyright (c) StrangeBee 2024

import { TaskStatus, ObservableReportLevel } from 'thehive-sdk';
import { ColorsType } from '@Types';

export const TLPColors: ColorsType[] = ['clear', 'green', 'amber', 'amber+strict', 'volcano'];
export const PAPColors: ColorsType[] = ['clear', 'green', 'amber', 'volcano'];
export const SeverityColors: ColorsType[] = ['cyan', 'yellow', 'amber', 'volcano'];

export enum HTMLColors {
    DEFAULT = 'default',
    BLUE = '#1890ff',
    WHITE = '#ffffff',
    YELLOW = '#E9CF42',
    GREEN = '#52c41a',
    PINK = '#eb2f96',
    GRAY = '#dedede',
    CLEAR = '#dedede',
    DARK_GRAY = '#b1b1b1',
    RED = '#d64b36',
    AMBER = '#ffa940',
    'AMBER+STRICT' = '#d77e15',
    CRIMSON = '#871400',
    CYAN = '#36cfc9',
    VOLCANO = '#fa541c',
}

export const TaskStatusColors: Record<TaskStatus, HTMLColors> = {
    [TaskStatus.COMPLETED]: HTMLColors.GREEN,
    [TaskStatus.IN_PROGRESS]: HTMLColors.YELLOW,
    [TaskStatus.WAITING]: HTMLColors.RED,
    [TaskStatus.CANCEL]: HTMLColors.BLUE,
};

export const SecurityColors: Record<string, string> = {
    amber: HTMLColors.AMBER,
    'amber+strict': HTMLColors['AMBER+STRICT'],
    green: HTMLColors.GREEN,
    white: HTMLColors.CLEAR,
    clear: HTMLColors.CLEAR,
    red: HTMLColors.RED,
    low: HTMLColors.CYAN,
    medium: HTMLColors.YELLOW,
    high: HTMLColors.AMBER,
    critical: HTMLColors.VOLCANO,
};

export const ObservableReportLevelColors: Record<ObservableReportLevel, HTMLColors> = {
    info: HTMLColors.BLUE,
    malicious: HTMLColors.RED,
    safe: HTMLColors.GREEN,
    suspicious: HTMLColors.AMBER,
};

export const RandomAntColors = [
    '#5f96f4',
    '#42daac',
    '#647796',
    '#fabf43',
    '#7b68f3',
    '#66cceb',
    '#9e67ba',
    '#ff9b59',
    '#0d9999',
    '#ff9ec5',
    '#ffccc7',
    '#ffd8bf',
    '#ffe7ba',
    '#fff1b8',
    '#ffffb8',
    '#f4ffb8',
    '#d9f7be',
    '#b5f5ec',
    '#bae7ff',
    '#d6e4ff',
    '#efdbff',
    '#ffd6e7',
];
